module.exports = __webpack_public_path__ + "img/page21_circleBg.a0b9cca1.png";